export const legalContent = {
  mentions: {
    fr: {
      title: 'Mentions légales',
      updated: 'Dernière mise à jour : octobre 2026',
      sections: [
        {
          heading: 'Éditeurs du site',
          body: [
            'Ce site est édité conjointement par les deux sociétés suivantes :',
            '',
            '— PATISSERIE M.T.A. (pôle pâtisseries orientales)',
            'SARL au capital de 10 000 €',
            'Siège social : 71 rue Etienne Dolet, 94140 Alfortville, France',
            'SIREN : 825 185 325 — SIRET (siège) : 825 185 325 00016',
            'RCS : Créteil B 825 185 325 (immatriculation du 24/01/2017)',
            'TVA intracommunautaire : FR72 825 185 325',
            '',
            '— MURAT FILO (pôle pâtes feuilletées : filo, kadayif, saç, üçgen, uzun)',
            'SAS au capital de 8 000 €',
            'Site de production : 2 avenue des Marronniers, 94380 Bonneuil-sur-Marne, France',
            'SIREN : 410 681 654 — SIRET (siège) : 410 681 654 00027',
            'RCS : Créteil B 410 681 654 (immatriculation du 09/01/1997)',
            'TVA intracommunautaire : FR56 410 681 654',
            'Code NAF/APE : 10.71A (Fabrication industrielle de pain et de pâtisserie fraîche)',
            'Convention collective : IDCC 3255',
            '',
            'Téléphone (contact commun) : 01 43 78 49 08',
            'Directeur de la publication : Michael Guleziyan (Gérant)'
          ]
        },
        {
          heading: 'Hébergement',
          body: [
            'Hébergeur : Emergent (Emergent Labs)',
            'Site web : https://emergent.sh',
            'Le site est hébergé sur l\'infrastructure cloud managée par Emergent.'
          ]
        },
        {
          heading: 'Propriété intellectuelle',
          body: [
            'L\'ensemble du contenu de ce site (textes, images, logo, graphismes, vidéos, structure) est la propriété exclusive des sociétés éditrices (PATISSERIE M.T.A. et MURAT FILO) ou de leurs partenaires et est protégé par le droit d\'auteur et le droit des marques.',
            'Toute reproduction, représentation, modification ou adaptation, totale ou partielle, est strictement interdite sans l\'autorisation écrite préalable des sociétés éditrices.'
          ]
        },
        {
          heading: 'Responsabilité',
          body: [
            'Les informations présentes sur ce site sont fournies à titre indicatif. Les sociétés éditrices (PATISSERIE M.T.A. et MURAT FILO) s\'efforcent d\'en assurer l\'exactitude et la mise à jour mais ne peuvent en garantir l\'exhaustivité.',
            'Les sociétés éditrices ne pourront être tenues responsables des éventuelles erreurs, omissions ou indisponibilités temporaires du site.'
          ]
        },
        {
          heading: 'Contact',
          body: [
            'Pour toute question concernant le site ou nos produits, vous pouvez nous écrire à l\'adresse suivante : 71 rue Etienne Dolet, 94140 Alfortville, ou nous appeler au 01 43 78 49 08.'
          ]
        }
      ]
    },
    en: {
      title: 'Legal notice',
      updated: 'Last updated: October 2026',
      sections: [
        {
          heading: 'Website publishers',
          body: [
            'This website is jointly published by the following two companies:',
            '',
            '— PATISSERIE M.T.A. (oriental pastries division)',
            'SARL (French limited company) with share capital of €10,000',
            'Head office: 71 rue Etienne Dolet, 94140 Alfortville, France',
            'SIREN: 825 185 325 — SIRET (head office): 825 185 325 00016',
            'RCS: Créteil B 825 185 325 (registered on 24/01/2017)',
            'EU VAT: FR72 825 185 325',
            '',
            '— MURAT FILO (filo & puff pastry division: filo, kadayif, saç, üçgen, uzun)',
            'SAS (French simplified joint-stock company) with share capital of €8,000',
            'Production site: 2 avenue des Marronniers, 94380 Bonneuil-sur-Marne, France',
            'SIREN: 410 681 654 — SIRET (head office): 410 681 654 00027',
            'RCS: Créteil B 410 681 654 (registered on 09/01/1997)',
            'EU VAT: FR56 410 681 654',
            'NAF/APE code: 10.71A (Industrial manufacture of bread and fresh pastry)',
            'Collective bargaining agreement: IDCC 3255',
            '',
            'Phone (shared contact): +33 1 43 78 49 08',
            'Publication director: Michael Guleziyan (Managing Director)'
          ]
        },
        {
          heading: 'Hosting',
          body: [
            'Host: Emergent (Emergent Labs)',
            'Website: https://emergent.sh',
            'The website is hosted on the managed cloud infrastructure provided by Emergent.'
          ]
        },
        {
          heading: 'Intellectual property',
          body: [
            'All content on this website (texts, images, logo, graphics, videos, structure) is the exclusive property of the publishers (PATISSERIE M.T.A. and MURAT FILO) or their partners and is protected by copyright and trademark law.',
            'Any reproduction, representation, modification or adaptation, in whole or in part, is strictly forbidden without the prior written consent of the publishers.'
          ]
        },
        {
          heading: 'Liability',
          body: [
            'Information on this website is provided for guidance only. The publishers (PATISSERIE M.T.A. and MURAT FILO) strive to keep it accurate and up to date but cannot guarantee its exhaustiveness.',
            'The publishers shall not be held liable for any errors, omissions or temporary unavailability of the site.'
          ]
        },
        {
          heading: 'Contact',
          body: [
            'For any question regarding the website or our products, please write to us at 71 rue Etienne Dolet, 94140 Alfortville, France, or call us at +33 1 43 78 49 08.'
          ]
        }
      ]
    }
  },
  confidentialite: {
    fr: {
      title: 'Politique de confidentialité',
      updated: 'Dernière mise à jour : octobre 2026',
      sections: [
        {
          heading: 'Collecte des données',
          body: [
            'Les sociétés éditrices (PATISSERIE M.T.A. et MURAT FILO) collectent uniquement les données que vous nous transmettez volontairement via le formulaire de contact (nom, message). Ces données sont utilisées exclusivement pour répondre à votre demande.',
            'Aucune donnée n\'est collectée à votre insu et aucune donnée n\'est transmise à des tiers à des fins commerciales.'
          ]
        },
        {
          heading: 'Finalité du traitement',
          body: [
            'Les données collectées sont destinées à : (1) répondre à vos demandes de contact ou de devis, (2) assurer le suivi de la relation commerciale.',
            'Elles sont conservées pendant la durée nécessaire à l\'accomplissement de ces finalités, soit au maximum 3 ans à compter du dernier contact.'
          ]
        },
        {
          heading: 'Vos droits (RGPD)',
          body: [
            'Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez des droits suivants : accès, rectification, effacement, limitation du traitement, opposition, portabilité.',
            'Pour exercer ces droits, vous pouvez nous écrire à : 71 rue Etienne Dolet, 94140 Alfortville — ou nous appeler au 01 43 78 49 08.'
          ]
        },
        {
          heading: 'Cookies',
          body: [
            'Ce site peut déposer des cookies techniques nécessaires à son bon fonctionnement (préférence de langue, bannière saisonnière déjà vue). Aucun cookie publicitaire ni de traçage tiers n\'est utilisé.',
            'Vous pouvez à tout moment supprimer ces cookies depuis les réglages de votre navigateur.'
          ]
        },
        {
          heading: 'Contact',
          body: [
            'Pour toute question relative à vos données personnelles, écrivez-nous à : 71 rue Etienne Dolet, 94140 Alfortville — ou appelez le 01 43 78 49 08.'
          ]
        }
      ]
    },
    en: {
      title: 'Privacy policy',
      updated: 'Last updated: October 2026',
      sections: [
        {
          heading: 'Data collection',
          body: [
            'The publishers (PATISSERIE M.T.A. and MURAT FILO) only collect data you voluntarily provide through the contact form (name, email, message). This data is used exclusively to respond to your enquiry.',
            'No data is collected without your knowledge and no data is shared with third parties for commercial purposes.'
          ]
        },
        {
          heading: 'Purpose of processing',
          body: [
            'Collected data is used to: (1) respond to your contact or quote requests, (2) manage the business relationship.',
            'Data is retained only for the time required to achieve these purposes, with a maximum of 3 years from the last contact.'
          ]
        },
        {
          heading: 'Your rights (GDPR)',
          body: [
            'Under the General Data Protection Regulation (GDPR), you have the following rights: access, rectification, erasure, restriction of processing, objection, portability.',
            'To exercise these rights, write to: 71 rue Etienne Dolet, 94140 Alfortville, France — or call +33 1 43 78 49 08.'
          ]
        },
        {
          heading: 'Cookies',
          body: [
            'This website may store technical cookies required for proper operation (language preference, seasonal banner dismissal). No advertising or third-party tracking cookies are used.',
            'You can delete these cookies at any time from your browser settings.'
          ]
        },
        {
          heading: 'Contact',
          body: [
            'For any question about your personal data, write to: 71 rue Etienne Dolet, 94140 Alfortville, France — or call +33 1 43 78 49 08.'
          ]
        }
      ]
    }
  },
  cgv: {
    fr: {
      title: 'Conditions générales de vente',
      updated: 'Dernière mise à jour : octobre 2026',
      sections: [
        {
          heading: 'Préambule',
          body: [
            'Les présentes Conditions Générales de Vente (CGV) régissent les relations commerciales entre PATISSERIE MTA (ci-après "le Vendeur") et toute personne physique ou morale (ci-après "l\'Acheteur") passant commande auprès du Vendeur.',
            'Toute commande implique l\'acceptation pleine et entière des présentes CGV.'
          ]
        },
        {
          heading: 'Produits',
          body: [
            'PATISSERIE MTA propose des pâtes feuilletées (filo, kadayif, saç yufka, üçgen yufka, uzun yufka) et des pâtisseries orientales artisanales.',
            'Les descriptions, poids et conditionnements sont indiqués sur le site à titre indicatif et peuvent évoluer sans préavis.'
          ]
        },
        {
          heading: 'Commandes',
          body: [
            'Les commandes sont passées par téléphone, email, ou directement en atelier à Alfortville pendant les heures d\'ouverture (lundi au samedi, 9h – 18h).',
            'Certains produits (Yeşil, grosses quantités) sont disponibles uniquement sur commande anticipée.'
          ]
        },
        {
          heading: 'Prix et paiement',
          body: [
            'Les prix sont exprimés en euros, HT ou TTC selon le profil de l\'acheteur (particulier ou professionnel).',
            'Les modalités de paiement sont précisées sur chaque devis ou bon de commande.'
          ]
        },
        {
          heading: 'Livraison',
          body: [
            'Les produits peuvent être retirés directement en atelier. La livraison est réservée uniquement aux grossistes, selon les conditions convenues avec le Vendeur.',
            'Les délais de livraison sont donnés à titre indicatif et peuvent varier selon la saison et le volume commandé.'
          ]
        },
        {
          heading: 'Garantie & réclamation',
          body: [
            'Les pâtisseries et pâtes feuilletées sont des produits frais soumis à conservation sous atmosphère protectrice et à température contrôlée (+4°C à +8°C).',
            'Toute réclamation doit être formulée dans les 48 heures suivant la réception des produits, par écrit à : 71 rue Etienne Dolet, 94140 Alfortville.'
          ]
        },
        {
          heading: 'Loi applicable',
          body: [
            'Les présentes CGV sont soumises au droit français. Tout litige sera porté devant les tribunaux compétents du siège social du Vendeur.'
          ]
        }
      ]
    },
    en: {
      title: 'Terms & conditions of sale',
      updated: 'Last updated: October 2026',
      sections: [
        {
          heading: 'Preamble',
          body: [
            'These Terms & Conditions of Sale (T&Cs) govern commercial relations between PATISSERIE MTA (the "Seller") and any individual or legal entity (the "Buyer") placing an order with the Seller.',
            'Any order implies full acceptance of these T&Cs.'
          ]
        },
        {
          heading: 'Products',
          body: [
            'PATISSERIE MTA offers filo, kadayif, saç yufka, üçgen yufka and uzun yufka doughs, as well as handmade oriental pastries.',
            'Descriptions, weights and packaging shown on the website are indicative and may change without notice.'
          ]
        },
        {
          heading: 'Orders',
          body: [
            'Orders can be placed by phone, email, or directly at the Alfortville workshop during opening hours (Monday to Saturday, 9am – 6pm).',
            'Some products (Yeşil, large quantities) are only available on advance order.'
          ]
        },
        {
          heading: 'Prices & payment',
          body: [
            'Prices are shown in euros, before or including VAT depending on the buyer\'s status (individual or professional).',
            'Payment terms are specified on each quote or order form.'
          ]
        },
        {
          heading: 'Delivery',
          body: [
            'Products can be collected at the workshop. Delivery is available to wholesalers only, according to terms agreed with the Seller.',
            'Delivery times are indicative and may vary depending on season and order volume.'
          ]
        },
        {
          heading: 'Warranty & claims',
          body: [
            'Pastries and puff pastry doughs are fresh products requiring packaging under protective atmosphere and controlled temperature (+4°C to +8°C).',
            'Any claim must be submitted within 48 hours of receipt, in writing to: 71 rue Etienne Dolet, 94140 Alfortville, France.'
          ]
        },
        {
          heading: 'Governing law',
          body: [
            'These T&Cs are governed by French law. Any dispute shall be brought before the competent courts of the Seller\'s head office.'
          ]
        }
      ]
    }
  }
};
